module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.b43c1da2.jpg";